/* eslint-disable */
export default {
  inAMeeting: 'En réunion',
  onMyWay: 'Sur la route',
  callMeBackIn: 'Rappelez-moi dans...',
  willCallYouBackIn: 'Je vous rappelle dans...',
  hour: 'heure',
  min: 'min',
} as const;

// @key: @#@"inAMeeting"@#@ @source: @#@"In a meeting"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in..."@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in..."@#@
// @key: @#@"hour"@#@ @source: @#@"hour"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
